import styled from 'styled-components';

const StyledMarginContainer = styled.div`
	margin-top: 20px;
`;

const StyledControlsContainer = styled.div`
	position: fixed;
	left: 0;
	bottom: 80px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 80px;
`;

export { StyledControlsContainer, StyledMarginContainer };
